import ControlState from '../../Shared/controlState';
import getControlSchemaProperty from '../../Shared/jsonSchemaUtilities/getControlSchemaProperty';
import PageState from '../../Shared/pageState';

export default (pages: PageState[]): ControlState[] => {
  const controls: ControlState[] = [];
  for (const page of pages) {
    for (const control of page.controls) {
      const utilizeHiddenComponents = getControlSchemaProperty(
        control,
        'utilizeHiddenComponents'
      ) as boolean;
      if (utilizeHiddenComponents) {
        controls.push(control);
      }
    }
  }
  return controls;
};
